export const formatUnicorn = (text?: string, args?: Record<string, string>): string => {
	if (!text || !args) {
		return '';
	}

	return Object.entries(args).reduce((prev: string, [key, value]: [string, string]) => {
		return prev.replace(new RegExp(`\\{${key}\\}`, 'gi'), value);
	}, text);
};
